import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { IconChevronDown, IconChevronUp } from '@sm/wds-icons';

import { PackageListPropTypes } from '~pricing/lib/proptypes';

const ComparisonTableCategory = ({ children, title, a11yId, packages = [], opened = false, className = '' }) => {
  const [open, setOpen] = useState(opened);
  const a11yButtonText = `Toggle list of features ${open ? 'closed' : 'open'}`;
  const ChevronIcon = open ? IconChevronDown : IconChevronUp;

  return (
    <tbody className={classnames('sm-comparison-table__category', className)} data-testid="ComparisonTableCategory">
      <tr>
        <th
          className="sm-comparison-table__category-cell"
          colSpan={packages.length + 1}
          scope="row"
          role="rowheader"
          data-testid="ComparisonTableCategory__FeatureCell"
          id={a11yId}
          onClick={() => setOpen(!open)}
          tabIndex="-1"
        >
          <span className="wds-type--card-title">{title}</span>
          <button
            onClick={() => setOpen(prevState => !prevState)}
            className="sm-comparison-table__category-toggle"
            data-testid="ComparisonTableCategory__Toggle"
            type="button"
            title={a11yButtonText}
            aria-label={a11yButtonText}
          >
            <span className="sm-comparison-table__open-indicator" aria-hidden="true">
              <ChevronIcon />
            </span>
          </button>
        </th>
      </tr>
      {open && children}
    </tbody>
  );
};

ComparisonTableCategory.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  a11yId: PropTypes.string.isRequired,
  packages: PackageListPropTypes,
  opened: PropTypes.bool,
  className: PropTypes.string,
};

ComparisonTableCategory.defaultProps = {
  packages: [],
  opened: false,
  className: '',
};

export default ComparisonTableCategory;
